import { render, staticRenderFns } from "./InternshipItem.vue?vue&type=template&id=5602b370&scoped=true&lang=pug&"
import script from "./InternshipItem.vue?vue&type=script&lang=ts&"
export * from "./InternshipItem.vue?vue&type=script&lang=ts&"
import style0 from "./InternshipItem.vue?vue&type=style&index=0&id=5602b370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5602b370",
  null
  
)

/* custom blocks */
import block0 from "./InternshipItem.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yml"
if (typeof block0 === 'function') block0(component)
import block1 from "./InternshipItem.vue?vue&type=custom&index=1&blockType=i18n&locale=ja&lang=yml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoadImage: require('/app/src/components/atoms/LoadImage.vue').default})
